/**
 * Layout scroll ownership for EmployeeLayout.
 *
 * - embed: full-height panels (timesheet, dense tables/reports) — main is overflow-hidden;
 *   the route's inner panel owns vertical scroll.
 * - content: dashboards and flowing pages — only main scrolls.
 */

const EMBED_SCROLL_ROUTE_PATTERNS = [
  /^\/employee\/ai-agent-survey$/,
  /^\/admin\/survey-response\/.+/,
  /^\/admin\/survey-responses$/,
  /^\/(?:admin|csg|pm)\/(?:project-hours|time-analysis)$/,
  /^\/admin\/approved-timesheets$/,
  /^\/pm\/approved-timesheet$/,
  /^\/csg\/approved-timesheets$/,
  /^\/admin\/timesheets\/[^/]+$/,
  /^\/admin\/employee-report$/,
  /^\/pm\/(?:review-timesheets|timesheet-logs)$/,
  /^\/admin\/skills\/manage$/,
  /^\/admin\/holidays$/,
  /^\/skills\/(?:resource-finder|bench-management)$/,
  /^\/admin\/(?:projects|clients|admins|project-managers|reporting-managers|notifications|optional-timesheets)$/,
  /^\/account\/audit-log$/,
  /^\/admin\/audit-log$/,
];

/** @typedef {'embed' | 'content'} LayoutScrollMode */

/**
 * @param {string} pathname
 * @param {{ isMobile?: boolean, isTablet?: boolean }} [options]
 * @returns {LayoutScrollMode}
 */
export function getLayoutScrollMode(pathname, { isMobile = false, isTablet = false } = {}) {
  /** Mobile/tablet: one page scroll (filters + data) — avoids nested scroll traps in flex layouts. */
  if (isMobile || isTablet) {
    return 'content';
  }
  if (EMBED_SCROLL_ROUTE_PATTERNS.some((pattern) => pattern.test(pathname))) {
    return 'embed';
  }
  return 'content';
}

export { EMBED_SCROLL_ROUTE_PATTERNS };
